import _ from 'lodash'

const selector = (state) => ({
  lookerUrl: _.get(state, 'analytics.lookerUrl', ''),
  userId: _.get(state, 'auth.user._id'),
})

export default selector
